import React, { useEffect, useState } from "react";
import {
    Carousel,
    CarouselContent,
    CarouselItem,
    CarouselNext,
    CarouselPrevious,
} from "../../../components/Carousel/Carousel";
import { Box, Card } from "@mui/material";
import bannerAiAgent from "../../../assets/SliderImage1.png";
import bannerCampaign from "../../../assets/SliderImage2.png";
import bannerFollowups from "../../../assets/SliderImage3.png";

const carouselImages = [
    {
        id: 1,
        src: bannerAiAgent,
        alt: "24X7 AI Agent For Sales & Leads Generation",
    },
    {
        id: 2,
        src: bannerCampaign,
        alt: "Get Smart Upsell Features With Campaign Intelligence",
    },
    {
        id: 3,
        src: bannerFollowups,
        alt: "Auto-Enquiry And Payment Follow Ups",
    },
];

export const FeaturedCarousel: React.FC<{
    sx?: any;
    isMobileFullWidth?: boolean;
}> = ({ sx, isMobileFullWidth = false }) => {
    const [api, setApi] = useState<any>(null);
    const [currentIndex, setCurrentIndex] = useState(0);

    useEffect(() => {
        if (!api) return;

        const onSelect = () => {
            setCurrentIndex(api.selectedScrollSnap());
        };

        api.on("select", onSelect);
        onSelect();

        const interval = setInterval(() => {
            if (api.canScrollNext()) {
                api.scrollNext();
            } else {
                api.scrollTo(0);
            }
        }, 4000);

        return () => {
            clearInterval(interval);
            api.off("select", onSelect);
        };
    }, [api]);

    return (
        <Box
            sx={{
                width: "100%",
                aspectRatio: isMobileFullWidth
                    ? { xs: "16 / 10.5", sm: "16 / 10" }
                    : { xs: "16 / 9.5", sm: "16 / 10" },
                position: "relative",
                overflow: "hidden",
                backgroundColor: "#083052",
                borderRadius: isMobileFullWidth
                    ? { xs: "0 0 20px 20px", sm: 3 }
                    : { xs: "18px", sm: 3 },
                boxShadow: isMobileFullWidth
                    ? { xs: "0 6px 20px rgba(0,0,0,0.08)", sm: "none" }
                    : { xs: "0 4px 16px rgba(0,0,0,0.08)", sm: "none" },
                ...sx,
            }}
        >
            <Carousel
                opts={{
                    align: "start",
                    loop: true,
                }}
                setApi={setApi}
            >
                <CarouselContent>
                    {carouselImages.map((item) => (
                        <CarouselItem key={item.id}>
                            <Card
                                sx={{
                                    position: "relative",
                                    height: "100%",
                                    overflow: "hidden",
                                    border: 0,
                                    boxShadow: "none",
                                    backgroundColor: "#083052",
                                    borderRadius: isMobileFullWidth
                                        ? { xs: "0 0 20px 20px", sm: 3 }
                                        : { xs: "18px", sm: 3 },
                                    margin: 0,
                                    padding: 0
                                }}
                            >
                                <Box
                                    component="img"
                                    src={item.src}
                                    alt={item.alt}
                                    sx={{
                                        width: "100%",
                                        height: "100%",
                                        objectFit: "cover",
                                        objectPosition: isMobileFullWidth ? { xs: "center top", sm: "center" } : "center",
                                        display: "block",
                                        transform: isMobileFullWidth
                                            ? { xs: "translateY(calc(env(safe-area-inset-top, 0px) + 26px))", sm: "none" }
                                            : "none",
                                    }}
                                />
                                {isMobileFullWidth && (
                                    <Box
                                        sx={{
                                            position: "absolute",
                                            top: 0,
                                            left: 0,
                                            right: 0,
                                            height: { xs: "calc(env(safe-area-inset-top, 0px) + 40px)", sm: 0 },
                                            background: "linear-gradient(180deg, #072a48 0%, rgba(8, 48, 82, 0.95) 55%, rgba(8, 48, 82, 0) 100%)",
                                            pointerEvents: "none",
                                            zIndex: 1,
                                        }}
                                    />
                                )}
                            </Card>
                        </CarouselItem>
                    ))}
                </CarouselContent>
                <CarouselPrevious sx={{ display: { xs: "none", sm: "inline-flex" } }} />
                <CarouselNext sx={{ display: { xs: "none", sm: "inline-flex" } }} />
            </Carousel>

            {/* Dots - inside frosted pill badge */}
            <Box
                sx={{
                    position: "absolute",
                    bottom: { xs: 10, sm: 12 },
                    right: { xs: 14, sm: 18 },
                    display: "flex",
                    alignItems: "center",
                    gap: 0.75,
                    zIndex: 2,
                    px: 1.25,
                    py: 0.5,
                    borderRadius: "9999px",
                    backgroundColor: "rgba(8, 48, 82, 0.75)",
                    backdropFilter: "blur(12px)",
                    WebkitBackdropFilter: "blur(12px)",
                    border: "1px solid rgba(255, 255, 255, 0.25)",
                    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.3)",
                }}
            >
                {carouselImages.map((_, idx) => (
                    <Box
                        key={idx}
                        onClick={() => api?.scrollTo(idx)}
                        sx={{
                            width: currentIndex === idx ? 18 : 6,
                            height: 6,
                            borderRadius: 3,
                            bgcolor: currentIndex === idx ? "#ffffff" : "rgba(255, 255, 255, 0.45)",
                            cursor: "pointer",
                            transition: "all 0.3s ease",
                        }}
                    />
                ))}
            </Box>
        </Box>
    );
};
